/**
 * Images Row Module
 */

export default function initImagesRow() {
  const imagesSliders = document.querySelectorAll('.images-swiper');
  if (!imagesSliders.length) return;

  imagesSliders.forEach(slider => {
    // Parse settings from data attribute
    const settingsData = slider.getAttribute('data-settings');
    const settings = settingsData ? JSON.parse(settingsData) : {};
    
    // Extract settings with defaults
    const autoplay = settings.autoplay !== false;
    const loop = settings.loop !== false;
    const showArrows = settings.showArrows === true;
    const showDots = settings.showDots === true;
    const autoplayDelay = settings.autoplayDelay || 5000;
    const pauseOnHover = settings.pauseOnHover !== false;
    const slidesPerView = settings.slidesPerView || 'auto';
    const slidesTablet = settings.slidesTablet || '2';
    const slidesMobile = settings.slidesMobile || '1';

    // Build Swiper configuration
    const swiperConfig = {
      slidesPerView: slidesPerView === 'auto' ? 'auto' : parseInt(slidesPerView),
      spaceBetween: 40,
      loop: loop,
      allowTouchMove: true,
      grabCursor: true,
      breakpoints: {}
    };

    // Add responsive breakpoints if not using auto
    if (slidesPerView !== 'auto') {
      const desktopSlides = parseInt(slidesPerView);
      const tabletSlides = parseInt(slidesTablet);
      const mobileSlides = parseInt(slidesMobile);

      // Only add breakpoints if they're different from desktop
      if (tabletSlides !== desktopSlides) {
        swiperConfig.breakpoints[768] = {
          slidesPerView: tabletSlides,
          spaceBetween: 30
        };
      }

      if (mobileSlides !== tabletSlides) {
        swiperConfig.breakpoints[0] = {
          slidesPerView: mobileSlides,
          spaceBetween: 20
        };
      } else if (mobileSlides !== desktopSlides) {
        swiperConfig.breakpoints[0] = {
          slidesPerView: mobileSlides,
          spaceBetween: 20
        };
      }
    } else {
      // Auto mode - just responsive spacing
      swiperConfig.breakpoints = {
        0: {
          spaceBetween: 20
        },
        768: {
          spaceBetween: 30
        },
        1024: {
          spaceBetween: 40
        }
      };
    }

    // Add modules based on settings
    const modules = [];
    if (autoplay) {
      modules.push(window.SwiperModules.Autoplay);
      swiperConfig.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover
      };
    }
    if (showArrows) {
      modules.push(window.SwiperModules.Navigation);
      swiperConfig.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      };
    }
    if (showDots) {
      modules.push(window.SwiperModules.Pagination);
      swiperConfig.pagination = {
        el: '.swiper-pagination',
        clickable: true
      };
    }
    
    swiperConfig.modules = modules;

    const imagesSwiper = new window.Swiper(slider, swiperConfig);

    // Pause on hover if enabled
    if (autoplay && pauseOnHover) {
      slider.addEventListener('mouseenter', () => {
        imagesSwiper.autoplay.stop();
      });

      slider.addEventListener('mouseleave', () => {
        imagesSwiper.autoplay.start();
      });
    }
  });
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', initImagesRow);
